export default __webpack_public_path__ + "assets/tt-qrcode.b4f1fd.png";